import { Accomodation } from "./accomodation.model";

export class Location {

    constructor(
      public id?: number,
      public fullAddress?: string,
      public city?: string,
      public country?: string,
      public latitude?: number,
      public longitude?: number,
      public accomodation?: Accomodation
    ){}
}
